import React from 'react';
import { Users } from 'lucide-react';
import PromptCard from '../ui/PromptCard';

interface InviteFamilyNudgeCardProps {
  onInvite: () => void;
  variant?: 'dashboard' | 'familyModal';
}

// PRO-336 — engagement nudge. Two surfaces:
//   - Dashboard: orchestrated via usePromptOrchestrator + ActivePrompt.
//     Visible only when active family has 1 member AND the user has
//     completed at least one chapter (story.progress >= 12, see
//     src/lib/promptPredicates.ts).
//   - FamilyManagementModal empty state: rendered directly when the
//     user is the only member, regardless of progress.
const InviteFamilyNudgeCard: React.FC<InviteFamilyNudgeCardProps> = ({
  onInvite,
  variant = 'dashboard',
}) => {
  const headline = variant === 'dashboard'
    ? 'Esto es de toda tu familia.'
    : 'Solo estás tú por ahora.';

  const body = variant === 'dashboard'
    ? 'Tu familia también va a querer oír esto. Invita a quien tú elijas.'
    : 'Cuando invites a alguien de tu familia, aparecerá aquí.';

  const ctaLabel = variant === 'dashboard'
    ? 'Invitar a mi familia'
    : 'Invitar a alguien';

  return (
    <PromptCard
      icon={Users}
      headline={headline}
      body={body}
      cta={{ label: ctaLabel, onClick: onInvite }}
    />
  );
};

export default InviteFamilyNudgeCard;
